/* eslint-disable no-console */

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(
        registrations
          .filter((registration) =>
            registration.scope.startsWith(`${window.location.origin}/dashboard/`)
          )
          .map((registration) => registration.unregister())
      );

      if ("caches" in window) {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames
            .filter(
              (cacheName) =>
                cacheName.includes("remotly_admin_dashboard") ||
                cacheName.includes("workbox")
            )
            .map((cacheName) => caches.delete(cacheName))
        );
      }
    } catch (error) {
      console.error("Error while clearing service worker cache:", error);
    }
  });
}
